import { Link } from 'react-router-dom';

interface BrandLogoProps {
  href?: string;
  size?: 'sm' | 'md';
}

const barHeights = ['h-3', 'h-4', 'h-5', 'h-6'];

export default function BrandLogo({ href = '/', size = 'md' }: BrandLogoProps) {
  const markSize = size === 'md' ? 'w-10 h-10' : 'w-9 h-9';
  const textSize = size === 'md' ? 'text-base md:text-lg' : 'text-sm';

  const content = (
    <span className="flex items-center gap-3 group cursor-pointer">
      <span className={`${markSize} flex items-end justify-center gap-[3px] pb-2 rounded-md border border-primary-700/60 bg-background-100/70`}>
        {barHeights.map((height, index) => (
          <span
            key={height}
            className={`${height} w-[3px] rounded-full bg-gradient-to-t from-accent-500 to-primary-300 transition-transform duration-300 group-hover:scale-y-110`}
            style={{ transformOrigin: 'bottom', transitionDelay: `${index * 40}ms` }}
          />
        ))}
      </span>
      <span className="flex flex-col leading-none">
        <span className={`font-heading font-extrabold tracking-[0.14em] text-foreground-950 ${textSize}`}>
          STRATEGIX
        </span>
        <span className="mt-1 text-[9px] tracking-[0.32em] text-primary-400/90 font-label">
          MARKETING AGENCY
        </span>
      </span>
    </span>
  );

  if (href.startsWith('#')) {
    return (
      <a href={href} className="inline-flex items-center">
        {content}
      </a>
    );
  }

  return (
    <Link to={href} className="inline-flex items-center">
      {content}
    </Link>
  );
}